/** 香港報稅工作台 menu（Overseas patch 265） */
export const HK_TAX_FILING_MENU_IDS = {
  desk: 990478,
  view: 990479,
  gate: 990480
}



// WEBPACK FOOTER //
// ./src/constants/hkTaxFiling.js